module.exports = __webpack_public_path__ + "img/link-recruta_white.e11e5feb.svg";